<template>
    <div class="my-5 p-1 text-base font-bold flex w-full">
        <div class="w-1/4 mt-1">
            <img
                :src="props.icon"
                alt="flag"
                class="h-9 w-9" >
        </div>
        <div class="w-3/4">
            <span class="pl-1">
                {{ props.title }}
            </span>
            <div class="flex">
                <div class="w-full mt-1 mr-3">
                    <progress
                        class="progress"
                        :value="props.width"
                        max="100" />
                </div>
            </div>
        </div>
        <span class="flex items-end">
            {{ props.width }}%
        </span>
    </div>
</template>
<script lang="ts" setup>
const props = defineProps({
  icon: {
    type: String,
    default: ''
  },
  title: {
    type: String,
    default: ''
  },
  width: {
    type: String,
    default: ''
  }
})
</script>
